import React, { useContext } from 'react'
import CartCtx from '../CartCtx'
import { createPortal } from 'react-dom'
import { Spinner } from 'react-bootstrap'
import '../../scss/components/main/cookiePopUp.scss'

const CookiePopUp = () => {

    const { cookieData, setAcceptCookie } = useContext(CartCtx)

    const isConfirmed = !!sessionStorage.getItem('cookie-allowed')

    if (isConfirmed) return <></>
    return (
        createPortal(
            <div style={{ position: 'relative', zIndex: 100000001 }}>
                <div className={`cookiePopUp`}>

                    {
                        cookieData ?
                            <div className='cookiePopUp-content'>
                                <div>
                                    <div className='cookiePopUp-content__text' dangerouslySetInnerHTML={{ __html: cookieData.text_cookie_1 }} />
                                    <div className='cookiePopUp-content__text' dangerouslySetInnerHTML={{ __html: cookieData.text_cookie_2 }} />
                                </div>
                                <button className='cookiePopUp-btn' onClick={setAcceptCookie}>
                                    {cookieData.text_cookie_button}
                                </button>
                            </div>
                            :
                            <></>
                        // <div className='cookiePopUp-spinerContainer'>
                        //     <Spinner animation='grow' />
                        // </div>
                    }
                </div>
            </div >,
            document.getElementById('root')
        )
    )
}

export default CookiePopUp